import { Folder, Asset, FolderContent } from '@/api/generatedApi';
import { useModal } from '@/hooks/useModal';

export const useSingleItemModals = <T extends FolderContent>({ onDeleted }: { onDeleted?: (item: T) => void }) => {
  const createFolderModal = useModal<Folder | undefined>();
  const deleteAssetModal = useModal<T>();
  const deleteFolderModal = useModal<T>();
  const renameFolderModal = useModal<Folder>();
  const moveFolderModal = useModal<Folder>();
  const moveAssetModal = useModal<Asset>();

  const openDeleteModal = (item: T) => {
    if (item.contentType === 'asset') {
      deleteAssetModal.open(item);
    } else if (item.contentType === 'folder') {
      deleteFolderModal.open(item);
    }
  };

  const confirmDeleteAsset = () => {
    const item = deleteAssetModal.item;
    deleteAssetModal.close();
    if (item) {
      onDeleted?.(item);
    }
  };

  const confirmDeleteFolder = () => {
    const item = deleteFolderModal.item;
    deleteFolderModal.close();
    if (item) {
      onDeleted?.(item);
    }
  };

  return {
    createFolderModal,
    deleteAssetModal,
    deleteFolderModal,
    renameFolderModal,
    moveFolderModal,
    moveAssetModal,
    openDeleteModal,
    confirmDeleteAsset,
    confirmDeleteFolder,
  };
};
